import React from 'react';
import { useTrialStatus } from '@/hooks/useTrialStatus';
import { TrialExpiredPage } from './TrialExpiredPage';
import { useTenants } from '@/services/tenants/useTenants';

export const TrialGuard = ({ children }: { children: React.ReactNode }) => {
  const { tenant } = useTenants();
  const { isExpired, isTrial } = useTrialStatus();

  if (isTrial && isExpired) {
    return <TrialExpiredPage expirationDate={tenant?.trialExpiresAt} />;
  }

  return <>{children}</>;
};
